export default {
  id: 149,
  title: 'Target #149 - Earthworm',
  url: 'https://cssbattle.dev/play/149',
  colors: ['#E38F66', '#FFFBDA'],
  solution:
    '<p a><p b><p c><style>[a],[b]{width:100;height:100}[b],body{background:#e38f66}[a],[c]{background:#fffbda;left:0}p{position:fixed}[a]{border-radius:0 20px;top:104;box-shadow:20px 60px #fffbda,80px 80px #fffbda}[b]{border-radius:0 10px;top:204;left:-20;box-shadow:60px -140px #e38f66,140px -60px #e38f66}[c]{border-radius:9in;width:40;height:40;top:84;box-shadow:160px 160px #fffbda}</style>',
}
